import { defineMessages } from 'react-intl-next';

export const messages: {
    pause: {
        defaultMessage: string;
        description: string;
        id: string;
    }; play: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	pause: {
		id: 'company-hub.cards-extension.autoscroll-wrapper.pause',
		defaultMessage: 'Pause',
		description:
			'Label text for the button that, when clicked, pauses the autoscroll of link cards',
	},
	play: {
		id: 'company-hub.cards-extension.autoscroll-wrapper.play',
		defaultMessage: 'Play',
		description: 'Label text for the button that, when clicked, plays the autoscroll of link cards',
	},
});
